<template>
  <div class="ade-data-table">
    <v-data-table
      :loading="computedLoading"
      :loading-text="$t('Chargement...')"
      :headers="headers"
      :items="items"
      :item-key="itemKey"
      :must-sort="true"
      :search="search"
      :disable-pagination="true"
      :options.sync="scopedOptions"
      height="300"
      fixed-header
      :server-items-length="serverItemsLength"
      hide-default-footer
      :show-select="hasAdminRights"
      v-model="selectedEntities"
      class="elevation-1 flex-grow-1 d-flex flex-column"
      v-bind="{ $scopedSlots }"
    >
      <template v-if="selectedEntities.length > 0" v-slot:top>
        <div class="ade-data-table-select-actions d-flex align-center">
          <div class="mr-2">
            {{ selectedEntities.length }}&nbsp;{{
              $t("selectionné", "selectionnés", selectedEntities.length)
            }}
          </div>
          <div>
            <slot name="bulkDeactivate" :selectedEntities="selectedEntities" />
          </div>
          <div>
            <slot
              name="bulkDelete"
              :selectedEntities="selectedEntities"
              :onSuccess="resetSelection"
            />
          </div>
          <div>
            <slot
              name="bulkConfirm"
              :selectedEntities="selectedEntities"
              :onSuccess="resetSelection"
            />
          </div>
        </div>
      </template>
      <template
        v-for="(header, i) in headers"
        v-slot:[`item.${header.value}`]="{ value }"
      >
        <div :key="i">
          <div v-html="$options.filters.colorTextWrapper(value, search)"></div>
        </div>
      </template>
      <template v-slot:no-data>
        {{ $t("Aucun résultat pour vos critères de recherche...") }}
        <v-btn color="primary" @click="resetSearch" class="ml-2">{{
          $t("Réinitialiser")
        }}</v-btn>
      </template>
      <template
        v-slot:body.append
        v-if="items.length < serverItemsLength && items.length"
      >
        <div v-intersect="loadMore"></div>
      </template>
      <template
        v-slot:header.actions
        v-if="serverItemsLength && serverItemsLength !== Infinity"
      >
        {{ serverItemsLength }} {{ $t(`résultats`) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapAuthGetters } = createNamespacedHelpers(`auth`);
export default {
  props: {
    headers: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    itemKey: {
      type: String,
      required: true
    },
    serverItemsLength: {
      type: Number,
      required: false,
      default: () => 100
    },
    search: {
      type: String,
      required: false,
      default: () => ""
    },
    fetch: {
      type: Function,
      required: true,
      default: () => () => {}
    },
    options: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    },
    updateOptions: {
      type: Function,
      required: true,
      default: () => () => {}
    },
    resetSearch: {
      type: Function,
      required: true,
      default: () => () => {}
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      localLoading: false,
      selectedEntities: [],
      itemsPerPage: 30,
      scopedOptions: this.options
    };
  },
  computed: {
    ...mapAuthGetters(["hasAdminRights"]),
    computedLoading() {
      return this.loading || this.localLoading;
    }
  },
  watch: {
    scopedOptions: {
      async handler() {
        this.updateOptions(this.scopedOptions);
        this.localLoading = true;
        await this.fetch({ reset: true });
        this.localLoading = false;
      },
      deep: true
    }
  },
  async mounted() {
    this.localLoading = true;
    await this.fetch({ reset: true });
    this.localLoading = false;
  },
  methods: {
    async loadMore(e) {
      if (e[0].isIntersecting && this.items.length && !this.localLoading) {
        this.localLoading = true;
        await this.fetch();
        this.localLoading = false;
      }
    },
    resetSelection() {
      this.selectedEntities = [];
    }
  }
};
</script>

<style lang="scss">
.ade-data-table {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1 1 auto;

  .v-data-table__wrapper {
    flex: 1 1 auto;
  }
}
.ade-data-table-select-actions {
  position: absolute;
  z-index: 5;
  top: 0;
  left: 56px;
  height: 47px;
  padding: 0 16px;
  background: #fff;
}
</style>
